import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Button,
  Icon,
  Layout,
  Tooltip,
} from 'antd';

const { Header } = Layout;

const LeftBox = styled.div`
  height: 100%;
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
`;

const RightBox = styled.div`
  height: 100%;
  width: 50%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const Title = styled.div`
  width: 100%;
  font-weight: bold;
  font-size: 1.3em;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-align: left;
`;

const SubTitle = styled.span`
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-align: left;
`;

const styles = {
  button: {
    backgroundColor: '#2d3e4f',
    color: 'white',
    height: '39px',
    width: '39px',
    marginLeft: '12px',
    fontSize: '23px',
  },
  header: {
    color: '#555555',
    backgroundColor: '#ecf0f1',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 12px',
    height: '60px',
    lineHeight: '1',
  },
};

const ChannelDetailHeader = ({
  canOpenChannelList,
  channelName,
  className,
  memberCount,
  onClickSetting,
  onOpenChannelList,
  onOpenVideoChatView,
}) => (
  <Header
    className={className}
    style={styles.header}
  >
    <LeftBox>
      <Title>
        {channelName}
      </Title>
      <SubTitle>
        <Icon
          type="user"
        />
        &nbsp;{memberCount}
      </SubTitle>
    </LeftBox>
    <RightBox>
      {
        canOpenChannelList && (
          <Tooltip
            title="Channel List"
          >
            <Button
              htmlType="button"
              icon="menu-unfold"
              shape="circle"
              style={styles.button}
              onClick={onOpenChannelList}
            />
          </Tooltip>
        )
      }
      <Tooltip
        title="Setting"
      >
        <Button
          htmlType="button"
          icon="setting"
          shape="circle"
          style={styles.button}
          onClick={onClickSetting}
        />
      </Tooltip>
      <Tooltip
        title="Video Chat"
      >
        <Button
          htmlType="button"
          icon="video-camera"
          shape="circle"
          style={styles.button}
          onClick={onOpenVideoChatView}
        />
      </Tooltip>
    </RightBox>
  </Header>
);

ChannelDetailHeader.propTypes = {
  channelName: PropTypes.string.isRequired,
  className: PropTypes.object,
  memberCount: PropTypes.number,
  onClickSetting: PropTypes.func.isRequired,
  onOpenChannelList: PropTypes.func.isRequired,
  onOpenVideoChatView: PropTypes.func.isRequired,
};

ChannelDetailHeader.defaultProps = {
  className: {},
  memberCount: 0,
};


export default ChannelDetailHeader;



// WEBPACK FOOTER //
// ./src/components/messaging/ChannelDetailHeader.js